import React from "react";
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram, FaPinterest, FaTiktok, FaYoutube } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="bg-[#13689b] text-white py-12">
        <hr/>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 mt-4">
        <div className="flex flex-col items-center space-y-6 md:space-y-0 md:flex-row md:justify-between">
          <div className="text-center md:text-left">
            <h2 className="text-2xl font-semibold">Why Me Solutions</h2>
            <p className="mt-2">Providing top-notch business solutions since 2024.</p>
          </div>
          <div className="flex space-x-6">
            <a
              href="https://www.facebook.com/profile.php?id=61559180705064"
              className="text-white-400 hover:text-black transition-colors duration-300"
              aria-label="Facebook"
            >
              <FaFacebookF size={24} />
            </a>
            <a
              href="https://www.pinterest.com/whymesolutions/"
              className="text-white hover:text-black transition-colors duration-300"
              aria-label="Twitter"
            >
              <FaPinterest size={24} />
            </a>
            <a
              href="https://www.linkedin.com/in/whyme-solutions-9017b9338/"
              className="text-white hover:text-black transition-colors duration-300"
              aria-label="LinkedIn"
            >
              <FaLinkedinIn size={24} />
            </a>
            <a
              href="https://www.instagram.com/whymesolutions/"
              className="text-white hover:text-black transition-colors duration-300"
              aria-label="Instagram"
            >
              <FaInstagram size={24} />
            </a>
            <a
              href="https://www.tiktok.com/@whyme.solutions?lang=en"
              className="text-white hover:text-black transition-colors duration-300"
              aria-label="Twitter"
            >
              <FaTiktok size={24} />
            </a>
            <a
              href="https://www.youtube.com/channel/UCmlqDkoSgoju6_vB6eYmjsA"
              className="text-white hover:text-black transition-colors duration-300"
              aria-label="Twitter"
            >
              <FaYoutube size={24} />
            </a>
          </div>
        </div>
        <div className="mt-8 text-center text-white">
          <p>&copy; 2024 Business Solution Provider. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
